module.exports = __webpack_public_path__ + "static/lightning-alert-d85b9f7427b5af44dceccb472ae5a95a.png";